<div role="dialog" aria-labelledby="modalSendButtonsAttendance" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="modalSendButtonsAttendance">
            {{ 'attendance.confirmationCloseAttendance.closeAttendanceTitle' | translate }}
            <br>
            <span class="text-muted fw-normal font-14">{{ 'attendance.confirmationCloseAttendance.closeAttendanceSubtitle' | translate }}</span>
          </h4>
          <button type="button" class="btn-close" [matDialogClose]="false"></button>
        </div>
        <div class="modal-body">
          <form [formGroup]="formGroup">
            @if (tabulations.length > 0) {
              <div class="d-flex flex-column mb-2 w-100">
                <label class="form-label">{{ 'attendance.confirmationCloseAttendance.selectCloseReason' | translate }}</label>
                <mat-select
                  class="form-control"
                  formControlName="tabulation"
                >
                  @for(item of tabulations; track $index) {
                    <mat-option [value]="item">
                      {{ item?.name }}
                    </mat-option>
                  }
                </mat-select>
                <small class="text-muted">
                  {{ 'attendance.confirmationCloseAttendance.closeReasonHelp' | translate }}
                </small>
              </div>
              <div class="d-flex flex-column w-100">
                <label class="form-label">{{ 'attendance.confirmationCloseAttendance.observation' | translate }}</label>
                <textarea
                  rows="3"
                  class="form-control custom-scroll-bar"
                  formControlName="description"
                ></textarea>
              </div>
            }

            @if (!isAttendant()) {
              <div class="custom-switch col-12 mt-2">
                <input
                  type="checkbox"
                  id="closingChange"
                  data-switch="success"
                  (change)="handleJustClosingChange($event)"
                />
                <label for="closingChange">
                  <span>{{ 'attendance.confirmationCloseAttendance.directClose' | translate }}</span>
                </label>
              </div>
              <small class="text-muted">
                {{ 'attendance.confirmationCloseAttendance.directCloseHelp' | translate }}
              </small>
            }
          </form>
        </div>
        <div class="modal-footer">
          <button class="btn btn-light" [matDialogClose]="false">
            {{ 'attendance.confirmationCloseAttendance.cancel' | translate }}
          </button>
          <button class="btn btn-primary" (click)="onClose()">
            {{ loading ? "" : ('attendance.confirmationCloseAttendance.close' | translate) }}

            @if(loading) {
              <mat-spinner
                diameter]="25"
                [color]="'accent'"
                mode="indeterminate"
              />
            }
          </button>
        </div>
      </div>
    </div>
</div>
